import { render, staticRenderFns } from "./WhoIsWhoForm.vue?vue&type=template&id=5bfa341c&scoped=true&lang=pug&"
import script from "./WhoIsWhoForm.vue?vue&type=script&lang=js&"
export * from "./WhoIsWhoForm.vue?vue&type=script&lang=js&"
import style0 from "./WhoIsWhoForm.vue?vue&type=style&index=0&id=5bfa341c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfa341c",
  null
  
)

export default component.exports